import { Entity, IField } from "@/app/fields/types";

export const commonFormFieldProps = <T extends Entity>(field: IField<T>) => ({
  isRequired: field.is_required,
  name: String(field.field),
  id: `form-field-${String(field.field)}`,
  "data-cy": `form-field-${String(field.field)}`,
  help: field.info,
});

export const requiredRule = <T extends Entity>(field: IField<T>) => ({
  ...(field.is_required
    ? {
        required: field.info,
      }
    : {}),
});
